import type { ExtraDetailsData } from './extraDetails';

export interface LoginProfileData {
  fullName?: string;
  height?: string;
  orientation?: string;
  energy?: string;
  age?: string;
  avatar?: string;
  socialLink?: string;
}

export interface LoginResumeContext {
  localStep: number;
  hasReachedFinalSummary: boolean;
  extraDetails: ExtraDetailsData | null;
}

export interface LoginResumeResult {
  step: number;
  hasReachedSummary: boolean;
  hasReachedFinalSummary: boolean;
}

function splitAvatarList(avatar?: string): string[] {
  return avatar ? avatar.split(', ').filter(Boolean) : [];
}

function hasSupplementProgress(extraDetails: ExtraDetailsData | null): boolean {
  return Object.keys(extraDetails?.additionalAnswers || {}).length > 0;
}

/** Xác định bước tiếp tục sau khi đăng nhập lại */
export function resolveLoginResumeStep(
  profile: LoginProfileData,
  context: LoginResumeContext
): LoginResumeResult {
  if (!profile.fullName) {
    return { step: 1, hasReachedSummary: false, hasReachedFinalSummary: false };
  }
  if (!profile.height) {
    return { step: 2, hasReachedSummary: false, hasReachedFinalSummary: false };
  }
  if (!profile.orientation) {
    return { step: 3, hasReachedSummary: false, hasReachedFinalSummary: false };
  }
  if (!profile.energy) {
    return { step: 4, hasReachedSummary: false, hasReachedFinalSummary: false };
  }
  if (!profile.age) {
    return { step: 5, hasReachedSummary: false, hasReachedFinalSummary: false };
  }
  if (splitAvatarList(profile.avatar).length === 0 || !profile.socialLink) {
    return { step: 6, hasReachedSummary: false, hasReachedFinalSummary: false };
  }

  const supplementStarted =
    context.hasReachedFinalSummary ||
    context.localStep >= 8 ||
    hasSupplementProgress(context.extraDetails);

  if (supplementStarted) {
    return {
      step: 13,
      hasReachedSummary: true,
      hasReachedFinalSummary: context.hasReachedFinalSummary || context.localStep >= 13,
    };
  }

  return {
    step: 7,
    hasReachedSummary: true,
    hasReachedFinalSummary: false,
  };
}